// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__3kurR","content":"Layout_content__88Srk"};